import { ExamBoard } from 'interfaces/ExamBoard'

export const returnFormattedExamBoard = (examBoard: ExamBoard) => `${examBoard.longName} (${examBoard.shortName})`
